import $ from 'jquery';
import React from 'react';
import { isMobile } from '../../constants/Constants';
import { SP_IMPORT_INIT_AREA } from '../../constants/Labels';
import { importSettings } from '../../helpers/tools';

class ImportPopUp extends React.Component {
  componentDidMount() {
    $(document).on('openPopUp', this.handleOpenPopUp);
  }
  componentWillUnmount() {
    $(document).off('openPopUp', this.handleOpenPopUp);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.importPopupOpen !== this.props.importPopupOpen && this.props.importPopupOpen) {
      $('#import-settings-content textarea')[0].value = SP_IMPORT_INIT_AREA;
      $('#import-settings-content .validationError').text('');
      $('#import-settings-content .validationError').hide();
    }
  }
  /**
   * Method to handle 'openPopUp' custom event
   * @param {Event} event
   * @param {string} target
   */
  handleOpenPopUp = () => {
    if (this.timeoutID) {
      this.props.restorePopUpConfiguration(this.timeoutID, '#apply-settings-btn');
    }
  };
  /**
   * Method that is called after a timeout to revert the Apply Button to the initial state
   */
  clearApplyButtonTimeout = () => {
    $(document).trigger(isMobile ? 'touchend' : 'mousedown', ['importPopUp']);
    $('#apply-settings-btn').text('Apply');
    clearTimeout(this.timeoutID);
    this.props.callback();
  };

  /**
   * Method to import configuration
   */
  onApply = () => {
    let settings = $('#import-settings-content textarea')[0].value;
    const validationError = $('#import-settings-content .validationError');
    validationError.hide();

    if (settings.length === 0 || settings === SP_IMPORT_INIT_AREA) {
      validationError.text('The settings can not be empty');
      validationError.show();
      return;
    }
    let importSettingsData = importSettings(settings);
    if (importSettingsData !== null) {
      $('#apply-settings-btn').text('Applied');
      this.timeoutID = setTimeout(this.clearApplyButtonTimeout, 1000);
      this.props.importSettings(importSettingsData);
    } else {
      validationError.text('The settings are not well-formed');
      validationError.show();
    }
  };

  onBlur = event => {
    if (event.target.value === '') {
      event.target.value = SP_IMPORT_INIT_AREA;
    }
  };

  onFocusArea = event => {
    if (event.target.value === SP_IMPORT_INIT_AREA) {
      event.target.value = '';
    }
  };

  render() {
    return (
      <div id="import-settings">
        <div id="import-settings-content">
          <textarea
            defaultValue={SP_IMPORT_INIT_AREA}
            onFocus={this.onFocusArea}
            onBlur={this.onBlur}
          ></textarea>
          <div className="validationError"></div>
        </div>
        <div id="apply-settings-btn" className="popUpBtn" onClick={() => this.onApply()}>
          Apply
        </div>
      </div>
    );
  }
}

export default ImportPopUp;
